export default "__VITE_ASSET__90bedd12__"